import React from 'react';
//import { Auth } from 'aws-amplify';
import { FormGroup, FormControl } from 'react-bootstrap';

class PrivacyPolicyText extends React.Component {
  constructor(props) {
    super(props);
  }

  async componentDidMount() {}
   
  render() {
    return (
      <div className='PrivacyPolicyText' style={{ marginBottom: '30px' }}>
        <span>

<p style={{whiteSpace: 'pre-wrap'}}>

<p>
Your privacy is important to us. It is Generated Systems Technologies, Inc.'s policy to respect your privacy and comply with any applicable law and regulation regarding any personal information we may collect about you, including across our website, https://generatedsystems.com, and other sites we own and operate.
</p>

<p>
Personal information is any information about you which can be used to identify you. This includes information about you as a person (such as name, address, and date of birth), your devices, payment details, and even information about how you use a website or online service.
</p>

<p>
In the event our site contains links to third-party sites and services, please be aware that those sites and services have their own privacy policies. After following a link to any third-party content, you should read their posted privacy policy information about how they collect and use personal information. This Privacy Policy does not apply to any of your activities after you leave our site.
</p>

<p>
This policy is effective as of 3 August 2022.
</p>

<p>
Last updated: 3 August 2022
</p>

<p style={{fontWeight: 'bold'}}>
</p>
<h4>
Information We Collect
</h4>

<p>
Information we collect falls into one of two categories: “voluntarily provided” information and “automatically collected” information.
</p>

<p>
“Voluntarily provided” information refers to any information you knowingly and actively provide us when using or participating in any of our services and promotions.
</p>

<p>
“Automatically collected” information refers to any information automatically sent by your devices in the course of accessing our products and services.
</p>

<p style={{fontWeight: 'bold'}}>
Log Data
</p>

<p>
When you visit our website, our servers may automatically log the standard data provided by your web browser. It may include your device’s Internet Protocol (IP) address, your browser type and version, the pages you visit, the time and date of your visit, the time spent on each page, and other details about your visit.
</p>

<p>
Additionally, if you encounter certain errors while using the site, we may automatically collect data about the error and the circumstances surrounding its occurrence. This data may include technical details about your device, what you were trying to do when the error happened, and other technical information relating to the problem. You may or may not receive notice of such errors, even in the moment they occur, that they have occurred, or what the nature of the error is.
</p>

<p>
Please be aware that while this information may not be personally identifying by itself, it may be possible to combine it with other data to personally identify individual persons.
</p>

<p style={{fontWeight: 'bold'}}>
Personal Information
</p>

<p>
We may ask for personal information — for example, when you register an account or when you contact us — which may include one or more of the following:
</p>

<ul>
<li>Name</li>
<li>Email</li>
<li>Phone/mobile number</li>
</ul>

<p style={{fontWeight: 'bold'}}>
Transaction Data
</p>

<p>
Transaction data refers to data that accumulates over the normal course of operation on our platform. This may include transaction records, stored files, user profiles, analytics data and other metrics, as well as other types of information, created or generated, as users interact with our services.
</p>

<p style={{fontWeight: 'bold'}}>
Legitimate Reasons for Processing Your Personal Information
</p>

<p>
We only collect and use your personal information when we have a legitimate reason for doing so. In which instance, we only collect personal information that is reasonably necessary to provide our services to you.
</p>

<p style={{fontWeight: 'bold'}}>
Collection and Use of Information
</p>

<p>
We may collect personal information from you when you do any of the following on our website:
</p>

<ul>
<li>Use a mobile device or web browser to access our content</li>
<li>Contact us via email, or on any similar technologies</li>
</ul>

<p>
We may collect, hold, use, and disclose information for the following purposes, and personal information will not be further processed in a manner that is incompatible with these purposes:
</p>

<ul>
<li>to provide you with our platform's core features and services</li>
<li>to enable you to customize or personalize your experience of our website</li>
<li>to contact and communicate with you</li>
<li>to enable you to access and use our website and associated applications</li>
<li>for security and fraud prevention, and to ensure that our sites and apps are safe, secure, and used in line with our terms of use</li>
</ul>

<p style={{fontWeight: 'bold'}}>
Security of Your Personal Information
</p>

<p>
When we collect and process personal information, and while we retain this information, we will protect it within commercially acceptable means to prevent loss and theft, as well as unauthorized access, disclosure, copying, use, or modification.
</p>

<p>
Although we will do our best to protect the personal information you provide to us, we advise that no method of electronic transmission or storage is 100% secure, and no one can guarantee absolute data security.
</p>

<p>
You are responsible for selecting any password and its overall security strength, ensuring the security of your own information within the bounds of our services.
For example, ensuring any passwords associated with accessing your personal information and accounts are secure and confidential.
</p>

<p style={{fontWeight: 'bold'}}>
How Long We Keep Your Personal Information
</p>

<p>
We keep your personal information only for as long as we need to. This time period may depend on what we are using your information for, in accordance with this privacy policy. For example, if you have provided us with personal information as part of creating an account with us, we may retain this information for the duration your account exists on our system. If your personal information is no longer required for this purpose, we will delete it or make it anonymous by removing all details that identify you.
</p>

<p>
However, if necessary, we may retain your personal information for our compliance with a legal, accounting, or reporting obligation or for archiving purposes in the public interest, scientific, or historical research purposes or statistical purposes.
</p>

<h4>
Children’s Privacy  
</h4>

<p>
We do not aim any of our products or services directly at children under the age of 13, and we do not knowingly collect personal information about children under 13.
</p>

<h4>
Disclosure of Personal Information to Third Parties
</h4>

<p>
We may disclose personal information to:
</p>

<ul>
<li>third-party service providers for the purpose of enabling them to provide their services, including (without limitation) IT service providers, data storage, hosting and server providers, maintenance or problem-solving providers, professional advisors, and payment systems operators</li>
<li>our employees, contractors, and/or related entities</li>
<li>an entity that buys, or to which we transfer all or substantially all of our assets and business</li>
</ul>

<p>
Third parties we currently use include:
</p>

<ul>
<li>Account aggregation</li>  
</ul>

<h4>
Your Rights and Controlling Your Personal Information
</h4>

<p>
<b>Your choice:</b> By providing personal information to us, you understand we will collect, hold, use, and disclose your personal information in accordance with this privacy policy. You do not have to provide personal information to us, however, if you do not, it may affect your use of our website or the products and/or services offered on or through it.
</p>

<p>
<b>Information from third parties:</b> If we receive personal information about you from a third party, we will protect it as set out in this privacy policy. If you are a third party providing personal information about somebody else, you represent and warrant that you have such person’s consent to provide the personal information to us.
</p>

<p>
<b>Correction:</b> If you believe that any information we hold about you is inaccurate, out of date, incomplete, irrelevant, or misleading, please contact us using the details provided in this privacy policy. We will take reasonable steps to correct any information found to be inaccurate, incomplete, misleading, or out of date.
</p>

<p>
<b>Non-discrimination:</b> We will not discriminate against you for exercising any of your rights over your personal information. Unless your personal information is required to provide you with a particular service or offer (for example processing transaction data), we will not deny you goods or services and/or charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties, or provide you with a different level or quality of goods or services.
</p>

<p>
<b>Notification of data breaches:</b> We will comply with laws applicable to us in respect of any data breach.
</p>

<p>
<b>Complaints:</b> If you believe that we have breached a relevant data protection law and wish to make a complaint, please contact us using the details below and provide us with full details of the alleged breach. We will promptly investigate your complaint and respond to you, in writing, setting out the outcome of our investigation and the steps we will take to deal with your complaint. You also have the right to contact a regulatory body or data protection authority in relation to your complaint.
</p>

<h4>
Business Transfers
</h4>

<p>
If we or our assets are acquired, or in the unlikely event that we go out of business or enter bankruptcy, we would include data, including your personal information, among the assets transferred to any parties who acquire us. You acknowledge that such transfers may occur, and that any parties who acquire us may, to the extent permitted by applicable law, continue to use your personal information according to this policy, which they will be required to assume as it is the basis for any ownership or use rights we have over such information.
</p>

<h4>
Limits of Our Policy
</h4>

<p>
Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and policies of those sites, and cannot accept responsibility or liability for their respective privacy practices.
</p>

<h4>
Changes to This Policy
</h4>

<p>
At our discretion, we may change our privacy policy to reflect updates to our business processes, current acceptable practices, or legislative or regulatory changes. If we decide to change this privacy policy, we will post the changes here at the same link by which you are accessing this privacy policy.
</p>

<p>
If the changes are significant, or if required by applicable law, we will contact you (based on your selected preferences for communications from us) and all our registered users with the new details and links to the updated or changed policy.
</p>

<p>
If required by law, we will get your permission or give you the opportunity to opt in to or opt out of, as applicable, any new uses of your personal information.
</p>

<p style={{fontWeight: 'bold'}}>
Do Not Track
</p>

<p>
Some browsers have a “Do Not Track” feature that lets you tell websites that you do not want to have your online activities tracked. At this time, we do not respond to browser “Do Not Track” signals.
</p>

<p>
We adhere to the standards outlined in this privacy policy, ensuring we collect and process personal information lawfully, fairly, transparently, and with legitimate, legal reasons for doing so.
</p>




<p style={{fontWeight: 'bold'}}>
California Notice of Collection
</p>

<p>
In the past 12 months, we have collected the following categories of personal information enumerated in the California Consumer Privacy Act:
</p>

<p>
Identifiers, such as name, email address, phone number account name, and an ID or number assigned to your account.
</p>

<p>
For more information on information we collect, including the sources we receive information from, review the “Information We Collect” section. We collect and use these categories of personal information for the business purposes described in the “Collection and Use of Information” section, including to provide and manage our Service.
</p>

<p style={{fontWeight: 'bold'}}>
Right to Know and Delete
</p>

<p>
If you are a California resident, you have rights to delete your personal information we collected and know certain information about our data practices in the preceding 12 months. In particular, you have the right to request the following from us:
</p>

<ul>
<li>The categories of personal information we have collected about you;</li>
<li>The categories of sources from which the personal information was collected;</li>
<li>The categories of personal information about you we disclosed for a business purpose or sold;</li>
<li>The categories of third parties to whom the personal information was disclosed for a business purpose or sold;</li>
<li>The business or commercial purpose for collecting or selling the personal information; and</li>
<li>The specific pieces of personal information we have collected about you.</li>
</ul>

<p>
To exercise any of these rights, please contact us using the details provided in this privacy policy.
</p>

<h4>
Contact Us
</h4>

<p>
For any questions or concerns regarding your privacy, you may contact us using the following details:
</p>

<p>
Generated Systems
<br/>
Privacy_Policy@generatedsystems.com
</p>

</p>
        </span>

      </div>
    );
  }
}

export default PrivacyPolicyText;
